/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionReport } from '../../models/subscription-report';

export interface GetSubscriptionReport$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected report entry
 */
  reportUid: string;
}

export function getSubscriptionReport(http: HttpClient, rootUrl: string, params: GetSubscriptionReport$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionReport>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptionReport.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('reportUid', params.reportUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionReport>;
    })
  );
}

getSubscriptionReport.PATH = '/custom/subscriptions/{uid}/reports/{reportUid}';
